import { StopNew } from "../../../ducks/data/route-with-stops/types";

type StopUnit = StopNew["units"][number];

const DriverStopUnitRow = ({ stopUnit }: { stopUnit: StopUnit }) => {
  const details: string[] = [];

  if (stopUnit.weight) {
    details.push(`${stopUnit.weight} kg`);
  }

  const dimEntries = [
    { value: stopUnit.length, label: "L" },
    { value: stopUnit.width, label: "W" },
    { value: stopUnit.height, label: "H" },
  ].filter((d) => d.value);
  if (dimEntries.length > 0) {
    const values = dimEntries.map((d) => d.value).join("×");
    const labels = dimEntries.map((d) => d.label).join(" x ");
    details.push(`${values} cm (${labels})`);
  }

  if (stopUnit.volume) {
    details.push(`${stopUnit.volume} m³`);
  }

  return (
    <div style={{ paddingBlock: 2 }}>
      <div>
        {stopUnit.quantity && <>{stopUnit.quantity} x </>}
        {stopUnit.name}
      </div>
      {details.length > 0 && (
        <div className="text-xs text-gray-500">{details.join(" · ")}</div>
      )}
    </div>
  );
};

export default DriverStopUnitRow;
